/* DistroHub — theme behaviours.
   Runs on every page. Every block is guarded, so a page that has no hero,
   no ticker and no rail simply skips those parts. */
(function () {
  "use strict";

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var hasGsap = typeof gsap !== 'undefined';

  if (hasGsap && typeof ScrollTrigger !== 'undefined') gsap.registerPlugin(ScrollTrigger);

  /* ---------------- smooth scroll ---------------- */
  var lenis = null;
  if (!reduced && typeof Lenis !== 'undefined' && hasGsap) {
    lenis = new Lenis({
      duration: 1.25,
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      smoothWheel: true
    });
    if (typeof ScrollTrigger !== 'undefined') lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
    gsap.ticker.lagSmoothing(0);
  }

  function scrollToEl(el, offset) {
    if (lenis) lenis.scrollTo(el, { offset: offset || -70, duration: 1.4 });
    else el.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth' });
  }

  /* ---------------- custom cursor ---------------- */
  var dot = document.getElementById('cursor-dot');
  var ring = document.getElementById('cursor-ring');
  if (dot && ring) {
    if (fine && !reduced && hasGsap) {
      document.documentElement.classList.add('has-cursor');
      var rx = innerWidth / 2, ry = innerHeight / 2, dx = rx, dy = ry;
      window.addEventListener('mousemove', function (e) {
        dx = e.clientX; dy = e.clientY;
        gsap.set(dot, { x: dx, y: dy });
      }, { passive: true });
      gsap.ticker.add(function () {
        rx += (dx - rx) * 0.16; ry += (dy - ry) * 0.16;
        gsap.set(ring, { x: rx, y: ry });
      });
      /* delegated, so it also covers markup injected after load */
      document.addEventListener('mouseover', function (e) {
        if (e.target.closest('[data-hot], a, button')) ring.classList.add('hot');
      });
      document.addEventListener('mouseout', function (e) {
        if (e.target.closest('[data-hot], a, button')) ring.classList.remove('hot');
      });
    } else {
      dot.remove();
      ring.remove();
    }
  }

  /* ---------------- magnetic buttons ---------------- */
  if (fine && !reduced && hasGsap) {
    document.querySelectorAll('.magnetic').forEach(function (el) {
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        gsap.to(el, {
          x: (e.clientX - r.left - r.width / 2) * 0.32,
          y: (e.clientY - r.top - r.height / 2) * 0.32,
          duration: 0.5, ease: 'power3.out'
        });
      });
      el.addEventListener('mouseleave', function () {
        gsap.to(el, { x: 0, y: 0, duration: 0.8, ease: 'elastic.out(1,0.4)' });
      });
    });
  }

  /* ---------------- counters ---------------- */
  function runCounters(root) {
    root.querySelectorAll('[data-count]').forEach(function (el) {
      var end = parseFloat(el.dataset.count);
      if (isNaN(end)) return;
      if (reduced || !hasGsap) { el.innerText = end.toLocaleString('en-US'); return; }
      var proxy = { v: 0 };
      gsap.to(proxy, {
        v: end, duration: 2.2, ease: 'power2.out',
        onUpdate: function () { el.innerText = Math.round(proxy.v).toLocaleString('en-US'); }
      });
    });
    root.querySelectorAll('[data-word]').forEach(function (el) {
      var w = el.dataset.word;
      if (reduced) { el.innerText = w; return; }
      var i = 0;
      var iv = setInterval(function () {
        el.innerText = w.slice(0, ++i);
        if (i >= w.length) clearInterval(iv);
      }, 90);
    });
  }

  /* ---------------- intro veil + hero ---------------- */
  var veil = document.getElementById('veil');
  var hero = document.querySelector('[data-hero]');

  window.addEventListener('load', function () {
    if (veil) setTimeout(function () { veil.classList.add('done'); }, reduced ? 0 : 1150);

    if (reduced || !hasGsap) {
      document.querySelectorAll('.rv').forEach(function (el) {
        el.style.opacity = 1; el.style.transform = 'none';
      });
      document.querySelectorAll('.rv-line>span').forEach(function (el) {
        el.style.transform = 'none';
      });
      document.querySelectorAll('[data-count],[data-word]').forEach(function (el) {
        if (el.dataset.count) el.innerText = parseFloat(el.dataset.count).toLocaleString('en-US');
        else el.innerText = el.dataset.word;
      });
      return;
    }

    if (!hero) return;
    gsap.timeline({ delay: veil ? 1.15 : 0.2, defaults: { ease: 'power4.out' } })
      .to(hero.querySelectorAll('.rv-line>span'), { y: 0, duration: 1.3, stagger: 0.12 }, 0)
      .to(hero.querySelectorAll('.hero-eyebrow'), { opacity: 1, y: 0, duration: 1 }, 0.15)
      .to(hero.querySelectorAll('.lede'), { opacity: 1, y: 0, duration: 1.1 }, 0.5)
      .to(hero.querySelectorAll('.hero-cta .rv'), { opacity: 1, y: 0, duration: 1, stagger: 0.1 }, 0.7)
      .to(hero.querySelectorAll('.stat'), {
        opacity: 1, y: 0, duration: 1, stagger: 0.09,
        onComplete: function () { runCounters(hero); }
      }, 0.9);
  });

  /* ---------------- scroll reveals ---------------- */
  if (!reduced && hasGsap && typeof ScrollTrigger !== 'undefined') {
    document.querySelectorAll('[data-reveal-scope]').forEach(function (sec) {
      if (hero && (sec === hero || hero.contains(sec))) return;

      var lines = sec.querySelectorAll('.rv-line>span');
      if (lines.length) {
        gsap.to(lines, {
          y: 0, duration: 1.2, ease: 'power4.out', stagger: 0.12,
          scrollTrigger: { trigger: sec, start: 'top 72%' }
        });
      }
      var items = sec.querySelectorAll('.rv');
      if (items.length) {
        gsap.to(items, {
          opacity: 1, y: 0, duration: 1.1, ease: 'power3.out', stagger: 0.09,
          scrollTrigger: { trigger: sec, start: 'top 70%' }
        });
      }
      if (sec.querySelector('[data-count],[data-word]')) {
        ScrollTrigger.create({
          trigger: sec, start: 'top 70%', once: true,
          onEnter: function () {
            runCounters(sec);
            var bars = sec.querySelectorAll('.bar');
            if (bars.length) gsap.to(bars, { scaleX: 1, duration: 1.6, ease: 'power3.out', stagger: 0.15 });
          }
        });
      }
    });

    document.querySelectorAll('.sec-head').forEach(function (h) {
      gsap.fromTo(h, { y: 40 }, {
        y: -40, ease: 'none',
        scrollTrigger: { trigger: h, start: 'top bottom', end: 'bottom top', scrub: 1.2 }
      });
    });

    /* dim the 3D stage once the hero has scrolled past, so copy reads cleanly */
    var stage = document.getElementById('stage');
    if (stage && hero) {
      gsap.to(stage, {
        opacity: 0.5, ease: 'none',
        scrollTrigger: { trigger: hero, start: 'bottom 80%', end: 'bottom 20%', scrub: true }
      });
    }
  }

  /* ---------------- tickers ---------------- */
  document.querySelectorAll('[data-ticker-track]').forEach(function (track) {
    track.innerHTML += track.innerHTML;
    if (!reduced && hasGsap) {
      gsap.to(track, {
        xPercent: -50,
        duration: parseFloat(track.dataset.tickerTrack) || 46,
        ease: 'none', repeat: -1
      });
    }
  });

  /* ---------------- horizontal rails ---------------- */
  document.querySelectorAll('[data-rail]').forEach(function (wrap) {
    var rail = wrap.querySelector('.rail');
    if (!rail) return;
    var step = function () {
      var card = rail.querySelector('.card3d, .rail-item');
      return card ? card.getBoundingClientRect().width + 22 : rail.clientWidth * 0.8;
    };
    var prev = wrap.querySelector('[data-rail-prev]');
    var next = wrap.querySelector('[data-rail-next]');
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
  });

  /* ---------------- 3D card tilt ---------------- */
  if (fine && !reduced && hasGsap) {
    document.querySelectorAll('.card3d').forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width;
        var py = (e.clientY - r.top) / r.height;
        card.style.setProperty('--mx', px * 100 + '%');
        card.style.setProperty('--my', py * 100 + '%');
        gsap.to(card, {
          rotateY: (px - 0.5) * 10, rotateX: (0.5 - py) * 8,
          transformPerspective: 900, duration: 0.6, ease: 'power3.out'
        });
      });
      card.addEventListener('mouseleave', function () {
        gsap.to(card, { rotateX: 0, rotateY: 0, duration: 0.9, ease: 'elastic.out(1,0.5)' });
      });
    });
  }

  /* ---------------- network map pulse ---------------- */
  if (!reduced && hasGsap && document.querySelector('.pulse')) {
    gsap.set('.pulse', { opacity: 0.8 });
    gsap.to('.pulse', {
      attr: { r: 26 }, opacity: 0, duration: 2.6, repeat: -1, ease: 'power1.out',
      onRepeat: function () { gsap.set('.pulse', { attr: { r: 6 }, opacity: 0.8 }); }
    });
    if (typeof ScrollTrigger !== 'undefined' && document.querySelector('.route.lit')) {
      gsap.from('.route.lit', {
        strokeDashoffset: 220, duration: 2.4, ease: 'power2.inOut', stagger: 0.15,
        scrollTrigger: { trigger: '.net-panel', start: 'top 65%' }
      });
    }
  }

  /* ---------------- header ---------------- */
  var header = document.getElementById('header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('scrolled', window.scrollY > 60);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------- mobile drawer ---------------- */
  var drawer = document.getElementById('nav-drawer');
  var drawerOpen = document.querySelector('[data-drawer-open]');
  var drawerClose = document.querySelector('[data-drawer-close]');
  if (drawer && drawerOpen) {
    var setDrawer = function (open) {
      drawer.classList.toggle('open', open);
      drawerOpen.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (lenis) open ? lenis.stop() : lenis.start();
      if (open) {
        var first = drawer.querySelector('a, button');
        if (first) first.focus();
      } else {
        drawerOpen.focus();
      }
    };
    drawerOpen.addEventListener('click', function () { setDrawer(!drawer.classList.contains('open')); });
    if (drawerClose) drawerClose.addEventListener('click', function () { setDrawer(false); });
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer || e.target.closest('a')) setDrawer(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) setDrawer(false);
    });
  }

  /* ---------------- anchors ---------------- */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var href = a.getAttribute('href');
      if (!href || href === '#') return;
      var target = null;
      try { target = document.querySelector(href); } catch (_) { return; }
      if (!target) return;
      e.preventDefault();
      scrollToEl(target);
    });
  });

  document.querySelectorAll('[data-to-top]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (lenis) lenis.scrollTo(0, { duration: 1.4 });
      else scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
    });
  });

  /* ---------------- contact form ---------------- */
  document.querySelectorAll('[data-contact-form]').forEach(function (wrap) {
    var form = wrap.querySelector('form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      var btn = form.querySelector('button[type="submit"] span:not(.fill)');
      var nameEl = form.querySelector('[name="contact[name]"]');
      var emailEl = form.querySelector('[name="contact[email]"]');
      var name = nameEl ? nameEl.value.trim() : 'ok';
      var email = emailEl ? emailEl.value.trim() : '';
      if (!name || !/.+@.+\..+/.test(email)) {
        e.preventDefault();
        if (btn) {
          var label = btn.textContent;
          btn.textContent = 'Add your name and a valid email';
          setTimeout(function () { btn.textContent = label; }, 2600);
        }
        return;
      }
      if (btn) btn.textContent = 'Sending…';
    });
  });

  /* Shopify reloads after a successful post — land the visitor on the reply. */
  var posted = document.querySelector('[data-form-success]');
  if (posted) {
    window.addEventListener('load', function () {
      setTimeout(function () { scrollToEl(posted, -140); }, reduced ? 0 : 900);
    });
  }
})();
